import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { SITE, img, openEnquiry } from "../config";
import { FLOOR_PLAN_GROUPS } from "../data/site";

const TITLE = "Atlanta Enclave Floor Plan | 1, 2 & 3 BHK";
const DESC =
    "Atlanta Enclave floor plan – explore 1, 2 & 3 BHK layouts at Shilphata, Thane. MIVAN-built homes with sun decks. RERA P51700077788. Get detailed plans on WhatsApp.";

const JSON_LD = [
    {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: TITLE,
        url: "https://atlantaenclave.com/floor-plans/",
        description: DESC,
        isPartOf: { "@type": "WebSite", name: "Atlanta Enclave", url: "https://atlantaenclave.com/" },
    },
];

export default function FloorPlans() {
    return (
        <div data-testid="floor-plans-page">
            <Seo title={TITLE} description={DESC} path="/floor-plans/" jsonLd={JSON_LD} />
            <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Floor Plans" }]} />

            <section className="container-x mt-8">
                <Reveal>
                    <p className="eyebrow">Shilphata · Thane</p>
                    <h1 className="font-display mt-3 max-w-3xl text-4xl font-medium leading-[1.1] text-[#23231f] sm:text-5xl">
                        Atlanta Enclave Floor Plan — 1, 2 &amp; 3 BHK
                    </h1>
                    <p className="mt-5 max-w-2xl text-sm leading-relaxed text-[#55534a] sm:text-base">
                        At Atlanta Enclave Shilphata, every floor plan is meticulously crafted to suit your lifestyle — from
                        compact yet stylish 1 BHK homes to luxurious, expansive 3 BHK residences. All homes are built using
                        advanced MIVAN technology, ensuring durability, precision and a seamless finish.
                    </p>
                </Reveal>
            </section>

            {FLOOR_PLAN_GROUPS.map((g) => (
                <section key={g.label} className="container-x mt-14" data-testid={`floor-plan-group-${g.label.replace(" ", "-").toLowerCase()}`}>
                    <Reveal>
                        <h2 className="font-display text-2xl font-semibold text-[#23231f] sm:text-3xl">
                            Atlanta Enclave {g.label} Floor Plans
                        </h2>
                    </Reveal>
                    <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                        {g.images.map((im, i) => (
                            <Reveal key={im} delay={i * 60}>
                                <img
                                    src={img(im)}
                                    alt={i === 0 ? `Atlanta Enclave ${g.label} floor plan` : `Atlanta Enclave ${g.label} floor plan – layout ${i + 1}`}
                                    className="frame-img w-full"
                                    loading="lazy"
                                    width="473"
                                    height="565"
                                    data-testid={`floor-plan-${g.label.charAt(0)}bhk-${i}`}
                                />
                            </Reveal>
                        ))}
                    </div>
                    <Reveal className="mt-4">
                        <Link
                            to={g.label === "1 BHK" ? "/1-bhk/" : "/2-bhk/"}
                            className="text-sm font-bold uppercase tracking-wider text-[#23231f] underline decoration-[#8f7f45] underline-offset-4 hover:text-[#6e6234]"
                            data-testid={`floor-plan-link-${g.label.charAt(0)}bhk`}
                        >
                            Explore Atlanta Enclave {g.label} homes
                        </Link>
                    </Reveal>
                </section>
            ))}

            <section className="container-x mt-14">
                <Reveal>
                    <div className="card-line flex flex-col items-start justify-between gap-5 p-6 sm:flex-row sm:items-center sm:p-8" data-testid="floor-plan-3bhk-note">
                        <div>
                            <h2 className="font-display text-2xl font-semibold text-[#23231f]">Atlanta Enclave 3 BHK Floor Plan</h2>
                            <p className="mt-2 max-w-xl text-sm text-[#55534a]">
                                The detailed 3 BHK floor plan (1080 sq.ft. carpet) is available on request. Enquire now and our
                                team will share it with you along with the latest price and availability.
                            </p>
                        </div>
                        <div className="flex flex-wrap gap-3">
                            <button onClick={openEnquiry} className="btn btn-gold" data-testid="floor-plans-get-price-button">
                                Get Price &amp; Floor Plan
                            </button>
                            <Link to="/3-bhk/" className="btn btn-line" data-testid="floor-plans-3bhk-link">
                                View 3 BHK
                            </Link>
                        </div>
                    </div>
                </Reveal>
            </section>
        </div>
    );
}
